import { Injectable } from '@angular/core';
import { ActionSheetController, AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CameraImageService } from 'src/app/shared/services/camera-image.service';

@Injectable()
export class SwodocNodeWoundMeasureService {
  constructor(
    private _translate: TranslateService,
    private _imageProvider: CameraImageService,
    private _actionSheetCtrl: ActionSheetController,
    private _alertCtrl: AlertController
  ) {}

  public async showSelectImageActionSheet(handler: (image, showMarker) => void) {
    const buttons = [
      {
        text: this._translate.instant('audit.node.image.select_image_actionsheet.camera'),
        handler: () => {
          // tslint:disable-next-line: no-floating-promises
          this._imageProvider
            .getPictureFromCamera()
            .then(value => handler(value, false))
            .catch(err => console.error(err));
        },
      },
      {
        text: this._translate.instant('audit.node.image.select_image_actionsheet.fotolibrary'),
        handler: () => {
          // tslint:disable-next-line: no-floating-promises
          this._imageProvider
            .getPictureFromGallery()
            .then(value => handler(value, false))
            .catch(err => console.error(err));
        },
      },
    ];

    buttons.push({
      text: this._translate.instant('audit.node.image.select_image_actionsheet.cancel'),
      handler: () => {},
    });

    const actionSheet = await this._actionSheetCtrl.create({
      buttons,
    });
    await actionSheet.present();
  }

  public async showEditImageActionSheet() {
    return new Promise(async resolve => {
      const actionSheet = await this._actionSheetCtrl.create({
        buttons: [
          {
            text: this._translate.instant('audit.node.image.edit_image_actionsheet.view'),
            handler: () => {
              resolve('show');
            },
          },
          {
            text: this._translate.instant('audit.node.image.edit_image_actionsheet.edit'),
            handler: () => {
              resolve('edit');
            },
          },
          {
            text: this._translate.instant('audit.node.image.edit_image_actionsheet.delete'),
            role: 'destructive',
            handler: () => {
              // tslint:disable-next-line: no-floating-promises
              this._alertCtrl
                .create({
                  header: this._translate.instant('audit.node.image.delete_dialog.title'),
                  message: this._translate.instant('audit.node.image.delete_dialog.text'),
                  buttons: [
                    {
                      text: this._translate.instant('audit.node.image.delete_dialog.cancel'),
                      role: 'cancel',
                      handler: () => {},
                    },
                    {
                      text: 'Ok',
                      handler: () => {
                        resolve('delete');
                      },
                    },
                  ],
                })
                .then(controller => controller.present());
            },
          },
          {
            text: this._translate.instant('audit.node.image.edit_image_actionsheet.cancel'),
            handler: () => {},
          },
        ],
      });
      await actionSheet.present();
    });
  }

  public async fileAsBase64(file: File) {
    return new Promise<string>(resolve => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onloadend = () => {
        resolve(fileReader.result as string);
      };
    });
  }
}
